import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { AutofocusDirective } from './directives/autofocus/autofocus.directive';
import { CommonModule } from '@angular/common';
import { ModalComponent } from './directives/modal';
import { ModalService } from './services/modal';
import { MaskUtil } from './utils/masking/mask-util';
import { ClickOutsideDirective } from './directives/click-outside/click-outside.directive';
import { DisneyDropdownComponent } from './components/disney-dropdown/disney-dropdown.component';
import { DisneyInputComponent } from './components/disney-input/disney-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule
    ],
    declarations: [
        AutofocusDirective,
        ModalComponent,
        DisneyDropdownComponent,
        DisneyInputComponent,
        ClickOutsideDirective
    ],
    exports: [
        AutofocusDirective,
        ModalComponent,
        DisneyDropdownComponent,
        ClickOutsideDirective,
        DisneyInputComponent
    ],
    providers: [
        ModalService,
        MaskUtil
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ]
})
export class SharedModule {}
